import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ICustomer } from '@whitelabel/helpers/types';
import type { RootState } from '..';

const slice = createSlice({
  name: 'customer',
  initialState: {} as { data: ICustomer },
  reducers: {
    setCustomer: (state, { payload }: PayloadAction<{ customer: ICustomer }>) => {
      state.data = payload.customer;
    },
  },
});

export const { setCustomer } = slice.actions;

export const customerReducer = slice.reducer;

export const selectCurrentCustomer = (state: RootState) => state && state.customer.data;
